import React from "react";
import ChangePageSection from "../sections/ChangePageSection/Content";
const ChangePage = () => {
  return <ChangePageSection />;
};

export default ChangePage;
